import { Component, Input, SimpleChanges } from '@angular/core';
import { MainDashboardResumeDTO } from '../../model/MainDashboardResumeDTO';

@Component({
  selector: 'locations-card',
  templateUrl: './locations-card.component.html',
  styleUrls: ['./locations-card.component.css']
})
export class LocationsCardComponent {

  @Input() dashboardDataResponse: MainDashboardResumeDTO;

  isLoading = false;

  totalLocationsByGPS = 0;
  online = 0;
  offline = 0;
  noReport = 0;

  onlinePercent = 0;
  offlinePercent = 0;
  noReportPercent = 0;

  // Configuración para los círculos de progreso
  // Valores fijos para viewBox - el escalado se maneja con CSS
  circleSize = 100;
  strokeWidth = 12;
  radius = 0;
  circumference = 0;

  constructor() {
    this.radius = (this.circleSize - this.strokeWidth) / 2;
    this.circumference = 2 * Math.PI * this.radius;
  }

 ngOnInit(): void {
    this.isLoading = true;
    if (this.dashboardDataResponse) 
      this.isLoading = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dashboardDataResponse'] && this.dashboardDataResponse) {
      this.totalLocationsByGPS = this.dashboardDataResponse.totalLocationsByGPS;
      this.online = this.dashboardDataResponse.totalLocations_Actives;
      this.offline = this.dashboardDataResponse.totalLocations_Inactives;
      this.noReport = this.dashboardDataResponse.totalLocations_NoReport;
      this.onlinePercent = this.getPercent(this.dashboardDataResponse.totalLocations_Actives);
      this.offlinePercent = this.getPercent(this.dashboardDataResponse.totalLocations_Inactives);
      this.noReportPercent = this.getPercent(this.dashboardDataResponse.totalLocations_NoReport);
      this.isLoading = false;
    }
  }

  ngOnDestroy(): void {
  }

  getPercent(categoryTotal: number) {
    if (!this.dashboardDataResponse || this.dashboardDataResponse.totalLocations === 0)
      return 0;
    var percentage = Number(((categoryTotal / this.dashboardDataResponse.totalLocations) * 100)?.toFixed(0));
    return percentage;
  }

  getCircleOffset(percent: number): number {
    if (!percent) 
      return this.circumference;
    const offset = this.circumference - ((percent / 100) * this.circumference);
    return offset;
  }

}
